<template>
  <div v-if="isAdmin">
    <b-card class="mb-3">
      <b-media>
        <h5 class="mt-0">NIE MOŻNA UTWORZYĆ NOWEJ LOKALIZACJI - JESTEŚ ADMINISTRATOREM</h5>
      </b-media>
    </b-card>
  </div>
  <div v-else class="page-container">
    <b-card class="mb-3">
      <b-media>
        <img
          src="../../../assets/iconfinder_location_718953.png"
          height="64"
          width="64"
          slot="aside"
          class="rounded"
        />
        <h5 class="mt-0">{{ form.name }}</h5>
      </b-media>
    </b-card>
    <div
      class="row no-gutters border rounded overflow-hidden flex-md-row mb-4 p-4 shadow-sm h-md-250 position-relative"
    >
      <b-form @submit.prevent="onSubmit" class="col-12">
        <h5>
          Szczegóły dotyczące lokalizacji
          <hr />
        </h5>
        <div class="row">
          <b-form-group
            id="input-group-name"
            label="Nazwa lokalizacji:"
            label-for="input-name"
            description=""
            class="col-6"
          >
            <b-form-input
              id="input-name"
              v-model="form.name"
              type="text"
              required
              placeholder="Wpisz nazwę lokalizacji"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-api-key"
            label="Klucz API:"
            label-for="input-api-key"
            description=""
            class="col-6"
          >
            <b-form-input
              id="input-api-url"
              v-model="form.api_key"
              type="text"
              required
              placeholder="Wpisz klucz API"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-api-url"
            label="Url serwera API:"
            label-for="input-api-url"
            description=""
            class="col-12"
          >
            <b-form-input
              id="input-api-url"
              v-model="form.api_url"
              type="url"
              required
              placeholder="Wpisz url serwera API"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-register-api-url"
            label="Url API Rejestracja Online:"
            label-for="input-register-api-url"
            description=""
            class="col-12"
          >
            <b-form-input
              id="input-register-api-url"
              v-model="form.registration_url"
              type="url"
              required
              placeholder="Wpisz url API Rejestracji Online"
            ></b-form-input>
          </b-form-group>
          <h5 class="col-12 mt-2">
            Adres
            <hr />
          </h5>
          <b-form-group
            id="input-group-address"
            label="Ulica wraz z numerem budynku oraz lokalu:"
            label-for="input-address"
            description=""
            class="col-6"
          >
            <b-form-input
              id="input-address"
              v-model="form.address"
              type="text"
              placeholder="Wpisz ulicę wraz z numerem budynku oraz lokalu"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-postal-code"
            label="Kod pocztowy:"
            label-for="input-posta-code"
            description=""
            class="col-2"
          >
            <b-form-input
              id="input-postal-code"
              v-model="form.postal_code"
              type="tel"
              placeholder="Wpisz kod pocztowy"
              v-mask="'##-###'"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-city"
            label="Miasto:"
            label-for="input-city"
            description=""
            class="col-4"
          >
            <b-form-input
              id="input-city"
              v-model="form.city"
              type="text"
              placeholder="Wpisz miasto"
            ></b-form-input>
          </b-form-group>
          <h5 class="col-12 mt-2">
            Dane kontaktowe
            <hr />
          </h5>
          <b-form-group
            id="input-group-register-problems-phone"
            label="Numer serwisowy (komórkowy):"
            label-for="input-register-problems-phone"
            description="Na ten numer telefonu będą przychodziły powiadomienia o nierozpoznanych SMS'ach zwrotnych od pacjentów oraz o braku potwierdzenia rejestracji."
            class="col-6"
          >
            <b-form-input
              id="input-register-problems-phone"
              v-model="form.contact_numbers.register_problems"
              type="tel"
              v-mask="'48 ### ### ###'"
              placeholder="Wpisz numer telefonu"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-consultant-info-phone"
            label="Numer kontaktowy dla konsultantów:"
            label-for="input-consultant-info-phone"
            description="Ten numer telefonu wyświetli się konsultantom w przypadku kiedy będą chcieli skontaktować się z placówką w razie wątpliwości dt. pacjenta."
            class="col-6"
          >
            <b-form-input
              id="input-consultant-info-phone"
              v-model="form.contact_numbers.consultant_info"
              type="tel"
              v-mask="'48 ### ### ###'"
              placeholder="Wpisz numer telefonu"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-landline"
            label="Numer kontaktowy dla pacjentów:"
            label-for="input-landline"
            description=""
            class="col-6"
          >
            <b-form-input
              id="input-landline"
              v-model="form.contact_numbers.landline"
              type="tel"
              required
              v-mask="'48 ### ### ###'"
              placeholder="Wpisz numer kontaktowy dla pacjenta"
            ></b-form-input>
          </b-form-group>
          <div class="col-12 row p-0">
            <div class="col-12 p-0">
              <b-button type="submit" variant="primary" class="float-right">Zapisz zmiany</b-button>
            </div>
          </div>
        </div>
      </b-form>
    </div>
    <b-modal id="ask-for-templates" v-model="askForTemplatesModal" hide-footer centered>
      <template #modal-title>
        Lokalizacja została dodana!
      </template>
      <div class="text-center">
        Czy chcesz utworzyc domyślne szablony dla lokalizacji?
      </div>
      <div class="text-center mt-3 d-flex flex-row justify-content-center" style="gap: 0.5rem;">
        <b-button variant="primary" @click="createDefaultTemplates">Tak</b-button>
        <b-button @click="closeDefaultTemplatesCreation">Nie</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'Modify',
  created() {
    moment.locale('pl')
  },
  data() {
    return {
      form: {
        contact_numbers: {
          register_problems: '',
          consultant_info: '',
          landline: '',
          create_templates: false
        }
      },
      visitGroups: [],
      allowedScopes: {},
      onlyExistingTags: true,
      limit: 0,
      scopes: 'Dostępne do wyboru: ',
      saving: false,
      invoiceDocuments: [],
      accountType: '',
      askForTemplatesModal: false,
      localizationId: null
    }
  },
  async mounted() {
    const vm = this
    vm.accountType = localStorage.getItem('account_type')
  },
  computed: {
    isAdmin() {
      return this.accountType === 'admin'
    },
    isSuperAdmin() {
      return this.accountType === 'super_admin'
    }
  },
  methods: {
    onSubmit() {
      const vm = this
      vm.$store.commit('addPageLoaderEvent', 'create-consultant')
      vm.$http
        .post('e-zacma/localization/create', vm.form)
        .then(response => {
          vm.$success('Dane lokalizacji zostały zapisane')
          vm.localizationId = response.data.id
          vm.$bvModal.show('ask-for-templates')
        })
        .catch(() => {
          vm.$error()
        })
        .finally(() => {
          vm.$store.commit('removePageLoaderEvent', 'create-consultant')
        })
    },
    parseJSON(response) {
      response.data.contact_numbers = JSON.parse(response.data.contact_numbers)
      response.data.sms_templates = JSON.parse(response.data.sms_templates)
      response.data.message_templates = JSON.parse(response.data.message_templates)
    },
    closeDefaultTemplatesCreation() {
      const vm = this
      vm.$router.push({ name: 'e-zacma-localizations' })
      vm.$bvModal.hide('ask-for-templates')
    },
    createDefaultTemplates() {
      const vm = this
      vm.$bvModal.hide('ask-for-templates')
      vm.$store.commit('addPageLoaderEvent', 'create-default-templates')
      vm.$http
        .post(`e-zacma/template/default/create/${vm.localizationId}`)
        .then(() => {
          vm.$success('Domyślne szablony zostały dodane')
        })
        .catch(() => {
          vm.$error()
        })
        .finally(() => {
          vm.$store.commit('removePageLoaderEvent', 'create-default-templates')
          vm.$router.push({ name: 'e-zacma-localizations' })
        })
    }
  }
}
</script>

<style scoped lang="scss">
.b-tab {
  height: 100%;
}
</style>
